import React from 'react';
import { TypewriterText } from '@/components/custom/typewriter-text';
import { cn } from '@/lib/utils';

// Banner "T.I.A com balão de fala" usado nas telas do aluno no tema playful.
// imageOffset/imageHeight/bubbleMaxWidth variam por imagem (cada pose da T.I.A
// tem uma largura renderizada diferente) e por isso ficam como props numéricas
// aplicadas via CSS var — classes arbitrárias do Tailwind não aceitam valor
// dinâmico direto, mas aceitam `var(--x)`, o que permite manter o valor
// responsivo (só usado a partir do md, quando a T.I.A vira absolute ao lado
// do balão; no mobile ela fica em fluxo normal, empilhada, com um tamanho fixo
// menor, para não estourar a largura da tela).
function TiaBanner({ image, imageAlt = 'T.I.A', imageHeight = 180, imageOffset = 170, imageClassName, bubbleMaxWidth = 520, bubbleCorner = 'bl', bubbleIcon, showLabel = false, text, decoration, className, children }) {
  return (
    <div
      className={cn('relative flex flex-col items-center gap-4 rounded-[24px] p-4 shadow-card md:flex-row md:gap-0 md:pl-[var(--tia-offset)]', className)}
      style={{ background: 'var(--color-bg-lilac)', '--tia-offset': `${imageOffset}px`, '--tia-height': `${imageHeight}px` }}
    >
      {decoration}

      <img
        src={image}
        alt={imageAlt}
        className={cn('pointer-events-none relative z-10 h-24 w-auto object-contain object-bottom md:absolute md:bottom-0 md:left-2 md:h-[var(--tia-height)]', imageClassName)}
      />

      <div
        className={cn('relative z-10 flex w-full items-start gap-3 rounded-[16px] bg-white p-5 shadow-card md:w-auto', bubbleCorner === 'bl' ? 'md:rounded-bl-none' : 'md:rounded-tl-none')}
        style={{ maxWidth: bubbleMaxWidth }}
      >
        <div>
          {showLabel && (
            <span
              className="block text-xs font-extrabold"
              style={{ color: 'var(--color-secondary-dark)' }}
            >
              T.I.A
            </span>
          )}
          <p
            className="mb-0 whitespace-pre-line text-sm font-bold leading-relaxed"
            style={{ color: '#222731' }}
          >
            <TypewriterText text={text} />
          </p>
        </div>

        {bubbleIcon && (
          <img
            src={bubbleIcon}
            alt=""
            className="h-auto w-4 shrink-0"
          />
        )}
      </div>

      {children && <div className="relative z-10 w-full shrink-0 md:ml-auto md:w-auto">{children}</div>}
    </div>
  );
}

export { TiaBanner };
